import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

exports.AdminBreadcrumb = styled(Breadcrumb)`
    align-items: flex-start;
    background-color: #fff;
    color: #007DC6;
    display: flex;
    font-family: Lato;
    font-size: 20px;
    justify-content: space-between;
    letter-spacing: 1px;
    text-transform: uppercase;

    & > li + li:before {
        content: "";
    }

    margin: 0;
    padding: 0;
`;

exports.AdminBreadcrumbItem = props => (
    <li className={props.active ? 'active' : ''}>
        {props.active ? <span>{props.children}</span> : <Link to={props.to}>{props.children}</Link>}
    </li>
);



// WEBPACK FOOTER //
// ./src/components/atoms/AdminBreadcrumb.js